module.exports = __webpack_public_path__ + "static/media/experiment-3.b97123b6.PNG";